import { createSlice } from '@reduxjs/toolkit';
import { createFilterInitialState, filterReducers } from 'common/utils/sliceUtils/filterSliceUtils';

import type { RootState } from '../../app/store';

const userAclEntriesSlice = createSlice({
    name: 'userAclEntries',
    initialState: createFilterInitialState(),
    reducers: () => ({
        ...filterReducers,
    })
});

// eslint-disable-next-line no-restricted-syntax
export default userAclEntriesSlice.reducer;
export const { addNewFilter, removeFilter, clearFilters } = userAclEntriesSlice.actions;
export const selectFilters = (state: RootState) => state.userAclEntries.filters;
